import { SubpageLayout, RoadmapNote, InfoGrid } from "@/components/site/SubpageLayout";

export default function MinorMetals() {
  return (
    <SubpageLayout
      overline="Expanding Capability"
      title="Minor Metal"
      accent="Refining"
      intro="Antimony and tin sit at the heart of modern lead alloys, solders and bearings. As a natural extension of our lead refining operations, Metalix XT is developing capacity to recover and refine these minor metals from industrial residues, drosses and scrap — giving our customers a single, integrated source."
    >
      <InfoGrid
        items={[
          {
            kicker: "Antimony",
            title: "Sb recovery",
            body: "Recovery of antimony from battery-grid drosses and antimonial residues — the same chemistry that hardens our Pb-Sb alloy range.",
          },
          {
            kicker: "Tin",
            title: "Sn refining",
            body: "Refining tin from solder scrap, tinned copper and plating residues into reusable metal for solder, bearing and alloy applications.",
          },
          {
            kicker: "Integrated",
            title: "One supply chain",
            body: "Minor metals recovered in-house feed directly into custom alloy production — tighter chemistry control, shorter lead times, fewer intermediaries.",
          },
        ]}
      />
      <RoadmapNote />
    </SubpageLayout>
  );
}
